import Vue from 'vue';
export default new Vue(); // 空Vue实例作为事件总线
